import React from "react";
import { C, radii, type } from "../../styles/tokens";

const STATUS_CONFIGS = {
  verified: { bg: C.successTint, text: C.success, label: "Verified" },
  success: { bg: C.successTint, text: C.success, label: "Success" },
  approved: { bg: C.successTint, text: C.success, label: "Approved" },
  active: { bg: C.successTint, text: C.success, label: "Active" },
  paid: { bg: C.successTint, text: C.success, label: "Paid" },

  pending: { bg: C.warningTint, text: C.warning, label: "Pending" },
  waiting: { bg: C.warningTint, text: C.warning, label: "Waiting" },
  expiring: { bg: C.warningTint, text: C.warning, label: "Expiring" },
  review: { bg: C.warningTint, text: C.warning, label: "Under review" },

  rejected: { bg: C.dangerTint, text: C.danger, label: "Rejected" },
  danger: { bg: C.dangerTint, text: C.danger, label: "Failed" },
  failed: { bg: C.dangerTint, text: C.danger, label: "Failed" },
  inactive: { bg: C.dangerTint, text: C.danger, label: "Inactive" },

  neutral: { bg: C.surfaceSunken, text: C.textMuted, label: "Neutral" },
};

/**
 * Status Pill (docs/BRAND_MANUAL.md, section 8)
 * Label style, 999 radius, tint fill with status colour text:
 *  - "Verified" success (#057642 / #DCF5E7)
 *  - "Pending" warning (#915907 / #FFF3D6)
 *  - "Rejected" danger (#B24020 / #FCEBE7)
 *  - Neutral surfaceSunken with textMuted for everything else.
 *  - Never an icon.
 */
export function Pill({ status = "neutral", label, style = {} }) {
  const key = String(status || "").toLowerCase().trim();
  const config = STATUS_CONFIGS[key] || STATUS_CONFIGS.neutral;
  const displayText = label || config.label;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "3px 10px",
        borderRadius: radii.pill,
        backgroundColor: config.bg,
        color: config.text,
        fontSize: type.label.fontSize,
        lineHeight: type.label.lineHeight,
        fontWeight: type.label.fontWeight,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {displayText}
    </span>
  );
}
